import React from 'react'
import { Link } from 'react-router-dom'

export default () => (
  <Link className="plus-icon" to="/pridat">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.912 39.912"><g transform="translate(0)"><rect width="10.485" height="39.912" transform="translate(14.713)" /><rect width="10.485" height="39.912" transform="translate(0 25.199) rotate(-90)" /></g></svg>
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/Intro/PlusIcon.js